import anchorGoLink from './anchorGoLink.vue'
export default anchorGoLink
